export const formLayoutInputTypes = {
  GROUP: 'Group',
  STRING: 'STRING',
  BOOLEAN: 'BOOLEAN',
  NUMBER: 'NUMBER',
  TEXTAREA: 'TEXTAREA',
  SELECT: 'SELECT',
  SEARCH: 'SEARCH',
  FILE: 'FILE',
  NOTE: 'NOTE',
  RADIO: 'RADIO',
};
export const supplierDocumentType = {
  SUPPLIER_MANAGEMENT: 'supplier_management',
  SUPPLIER_USER: 'supplier_user',
};
